import { render, staticRenderFns } from "./ContactusManagement.vue?vue&type=template&id=d0d275cc&scoped=true"
import script from "./ContactusManagement.vue?vue&type=script&lang=js"
export * from "./ContactusManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/background/contactus.css?vue&type=style&index=0&id=d0d275cc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d275cc",
  null
  
)

export default component.exports